/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
var CharacterSelectorTab = function (editor) {
  var signals = editor.signals
  var container = new UI.Panel()
  container.setId('characterSelectorTab')
  container.className = "assetSelectorContainer"
  var selectedNode = null
  var values

  function build() {
    container.clear()
    if (selectedNode === null) return
    values = {}

    let selectedCharacter = selectedNode.data
      .selectedValues
      .find(selectedValue => selectedValue.key === 'selectedCharacter')

    editor.characterModels.forEach(characterModel => {
      var row = new UI.Row()
      try {
        var image = new UI.Image(characterModel.image.imageURL)
          .setDataName(characterModel.name)
          .setWidth('180px')
          .addHoverOver(
            characterModel.image.imageURL,
            characterModel.name,
            characterModel.description,
            characterModel.service
          )
        image.onClick(function (e) {
          selectedCharacter.value = characterModel.name
          signals.panelNodeSelected.dispatch(selectedNode)
        })
        row.add(image).setTextAlign('center')
        container.add(row)
      }
      catch (err) {
        console.log(err, characterModel)
      }
    })
  }

  signals.showSelector.add(function (node) {
    const selectedCharacter = node.data
      .selectedValues
      .find(selectedValue => selectedValue.key === 'selectedCharacter')
    if (selectedCharacter.value) {
      signals.panelNodeSelected.dispatch(node)
    } else {
      selectedNode = node
      build()
    }
  })

  signals.effectCompiled.add(build)

  return container
}

export default CharacterSelectorTab



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/CharacterSelectorTab.js
// module id = null
// module chunks = 